export var EBcHospitalHisConfigNetworkType;
(function (EBcHospitalHisConfigNetworkType) {
    EBcHospitalHisConfigNetworkType[EBcHospitalHisConfigNetworkType["None"] = 0] = "None";
    EBcHospitalHisConfigNetworkType[EBcHospitalHisConfigNetworkType["Wired"] = 1] = "Wired";
    EBcHospitalHisConfigNetworkType[EBcHospitalHisConfigNetworkType["Wiredless"] = 2] = "Wiredless";
})(EBcHospitalHisConfigNetworkType || (EBcHospitalHisConfigNetworkType = {}));
export var EBcHospitalHisConfigDatabaseType;
(function (EBcHospitalHisConfigDatabaseType) {
    EBcHospitalHisConfigDatabaseType["None"] = "";
    EBcHospitalHisConfigDatabaseType["SQLServer"] = "SQLServer";
    EBcHospitalHisConfigDatabaseType["Oracle"] = "Oracle";
    EBcHospitalHisConfigDatabaseType["MySQL"] = "MySQL";
    EBcHospitalHisConfigDatabaseType["Other"] = "\u5176\u4ED6";
})(EBcHospitalHisConfigDatabaseType || (EBcHospitalHisConfigDatabaseType = {}));
export var EBcDeviceType;
(function (EBcDeviceType) {
    EBcDeviceType["Xilin"] = "\u53F0\u5F0F\u897F\u6797\u8BBE\u5907";
    EBcDeviceType["Ampul"] = "\u53F0\u5F0F\u5B89\u74FF\u8BBE\u5907";
    EBcDeviceType["Auto"] = "\u7EFC\u5408\u914D\u836F\u8BBE\u5907";
    EBcDeviceType["Liquid"] = "\u5206\u6DB2\u4EEA\u8BBE\u5907";
    EBcDeviceType["PreDissolve"] = "\u9884\u6EB6\u4EEA\u8BBE\u5907";
    EBcDeviceType["EndoscopeArk"] = "\u5185\u955C\u67DC\u8BBE\u5907";
    EBcDeviceType["CleaningMachine"] = "\u6E05\u6D17\u673A\u8BBE\u5907";
    EBcDeviceType["BreathTrain"] = "\u547C\u5438\u8BAD\u7EC3\u8BBE\u5907";
    EBcDeviceType["Other"] = "\u5176\u4ED6\u8BBE\u5907";
})(EBcDeviceType || (EBcDeviceType = {}));
